module.exports = __webpack_public_path__ + "img/Contact.54c79f08.png";